import { render, staticRenderFns } from "./ReportsCard.vue?vue&type=template&id=2d76cc8d&scoped=true&"
import script from "./ReportsCard.vue?vue&type=script&lang=ts&"
export * from "./ReportsCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsCard.vue?vue&type=style&index=0&id=2d76cc8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76cc8d",
  null
  
)

export default component.exports